<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const emit = defineEmits(['confirm']);

const { t } = useI18n();
const dialogRef = ref(null);
const reason = ref('');
const durationMinutes = ref(1440);

const open = () => {
  reason.value = '';
  durationMinutes.value = 1440;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const confirm = () => {
  emit('confirm', {
    reason: reason.value.trim(),
    durationMinutes: Number(durationMinutes.value),
  });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="md"
    :title="t('CONTACTS_LAYOUT.BLOCK_DIALOG.TITLE')"
    :description="t('CONTACTS_LAYOUT.BLOCK_DIALOG.DESCRIPTION')"
    :confirm-button-label="t('CONTACTS_LAYOUT.BLOCK_DIALOG.CONFIRM')"
    @confirm="confirm"
  >
    <div class="flex flex-col gap-5">
      <Input
        v-model="reason"
        :label="t('CONTACTS_LAYOUT.BLOCK_DIALOG.REASON')"
        :placeholder="t('CONTACTS_LAYOUT.BLOCK_DIALOG.REASON_PLACEHOLDER')"
        maxlength="500"
      />
      <label class="flex flex-col gap-1 text-sm text-n-slate-12">
        <span class="text-heading-3">
          {{ t('CONTACTS_LAYOUT.BLOCK_DIALOG.DURATION') }}
        </span>
        <select
          v-model="durationMinutes"
          class="h-10 px-3 rounded-lg border-0 outline outline-1 outline-n-weak bg-n-alpha-black2 text-n-slate-12"
        >
          <option :value="60">
            {{ t('CONTACTS_LAYOUT.BLOCK_DIALOG.ONE_HOUR') }}
          </option>
          <option :value="1440">
            {{ t('CONTACTS_LAYOUT.BLOCK_DIALOG.ONE_DAY') }}
          </option>
          <option :value="10080">
            {{ t('CONTACTS_LAYOUT.BLOCK_DIALOG.SEVEN_DAYS') }}
          </option>
          <option :value="0">
            {{ t('CONTACTS_LAYOUT.BLOCK_DIALOG.PERMANENT') }}
          </option>
        </select>
      </label>
    </div>
  </Dialog>
</template>
